import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const checkboxRequiredValidator: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const isChecked = control.value === true;
  return isChecked ? null : { checkboxRequired: true };
};
